import { pathgen } from 'object-path-generator';
export const AttachmentsTestIds = pathgen('AttachmentsTestIds');